import {bhDateToYearMonthDay, dateFromBhDateString} from './business-hours.directive';

ExceptionEditionController.$inject = ['$scope', '$rootScope', '$mdDialog', 'exception'];
export function ExceptionEditionController($scope, $rootScope, $mdDialog, exception) {
  
  $scope.ok = ok;
  $scope.cancel = cancel;
  
  init();

  function ok() {
    const closedAllDay = !$scope.notClosedAllDay;
    const start = $scope.model.start;
    const end = $scope.model.end;
    $mdDialog.hide({
      'date': bhDateToYearMonthDay($scope.model.date),
      'start': {
        'h': closedAllDay ? 0 : start.getHours(), 
        'm': closedAllDay ? 0 : start.getMinutes()
      },
      'end': {
        'h': closedAllDay ? 0 : end.getHours(), 
        'm': closedAllDay ? 0 : end.getMinutes()
      }
    });
  };

  function cancel() {
    $mdDialog.cancel();
  };

  function checkStartBeforeEndAndUpdateValidity() {
    const coherent =   !$scope.notClosedAllDay 
                    || !$scope.model.start 
                    || !$scope.model.end 
                    || $scope.model.start <= $scope.model.end;
    $scope.exceptionForm.$setValidity('startBeforeEnd', coherent);
  };

  function init() {
    $scope.notClosedAllDay = !(exception.start.h === exception.end.h && exception.start.m === exception.end.m);
    $scope.model = {
      'date': dateFromBhDateString(exception.date),
      'start': new Date(2016, 10, 3, exception.start.h, exception.start.m),
      'end': new Date(2016, 10, 3, exception.end.h, exception.end.m)
    }

    var unsubscribeFn = $rootScope.$on('mdpTimePickerUpdated', checkStartBeforeEndAndUpdateValidity);
    $scope.$on('$destroy', unsubscribeFn);
  }

}
